import { Head } from '@inertiajs/react'
import Layout from './Layout'
import AccountBadge from './Components/AccountBadge'
import IconBadge from './Components/IconBadge'
import PhoneButton from '../../Components/PhoneButton'
import Button from '../../Components/Button'

export default function KitchenClosed({ account, next_opening, kitchen_hours }) {
  const openDays = kitchen_hours?.filter(h => !h.closed) || []

  return (
    <>
      <Head title={`Kitchen Closed - ${account.name}`} />
      <Layout account={account}>
        <div className="flex flex-col min-h-screen">
        <div className="bg-sky-900 text-white px-6 py-8 text-center flex flex-col items-center justify-center">
          <div className="mx-auto mb-4">
            <AccountBadge name={account.name} logoUrl={account.logo_url} size="md" />
          </div>
          <h1 className="text-xl font-bold mb-1">
            {account.name}
          </h1>
        </div>

        <div className="flex-1 px-6 py-8 flex flex-col items-center bg-gray-100">
          {/* Closed Icon */}
          <IconBadge label="Kitchen closed" color="bg-amber-500" className="mb-6">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </IconBadge>

          <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">
            Kitchen Closed
          </h2>

          <p className="text-gray-600 text-center mb-6 max-w-sm">
            Sorry, the kitchen is currently closed for online orders.
          </p>

          {next_opening && (
            <div className="bg-white rounded-xl p-4 mb-6 w-full max-w-sm shadow-sm" role="status">
              <p className="text-gray-600 text-center text-sm mb-1">We open next</p>
              <p className="text-xl font-bold text-sky-900 text-center">
                {next_opening}
              </p>
            </div>
          )}

          {openDays.length > 0 && (
            <section className="bg-white rounded-xl p-4 mb-6 w-full max-w-sm shadow-sm" aria-label="Kitchen hours">
              <h3 className="text-sm font-medium text-gray-700 text-center mb-3">
                Kitchen Hours
              </h3>
              <dl className="space-y-2">
                {kitchen_hours.map((day) => (
                  <div key={day.day} className="flex justify-between text-sm">
                    <dt className="text-gray-600">{day.day}</dt>
                    <dd className={day.closed ? "text-gray-400" : "text-gray-900 font-medium"}>
                      {day.closed ? "Closed" : `${day.open_at} - ${day.close_at}`}
                    </dd>
                  </div>
                ))}
              </dl>
            </section>
          )}

          <div className="w-full max-w-sm mt-auto space-y-3">
            <PhoneButton
              phoneNumber={account.phone}
              variant="primary"
              className="shadow-lg"
              ariaLabel={`Call to order at ${account.phone}`}
            >
              Call to Order: {account.phone}
            </PhoneButton>

            <Button
              onClick={() => window.location.href = `/${account.slug}/order`}
              variant="secondary"
              theme="dark"
              size="md"
              fullWidth
            >
              Back to Home
            </Button>
          </div>
        </div>
      </div>
      </Layout>
    </>
  )
}
